
document.addEventListener("DOMContentLoaded", function() {
    const slider = document.querySelector(".slider");
    const slides = slider.querySelectorAll(".list .item");
    const prevBtn = slider.querySelector("#prev");
    const nextBtn = slider.querySelector("#next");
    const dots = slider.querySelectorAll(".dots li");
    let currentIndex = 0;
    const total = slides.length;

    // Function to show slide at index
    function showSlide(index) {
        slides.forEach((slide, i) => {
            slide.style.display = i === index ? "block" : "none";
            dots[i].classList.toggle("active", i === index);
        });
    }

    // Initial display
    showSlide(currentIndex);

    // Next slide
    nextBtn.addEventListener("click", () => {
        currentIndex = (currentIndex + 1) % total;
        showSlide(currentIndex);
    });

    // Previous slide
    prevBtn.addEventListener("click", () => {
        currentIndex = (currentIndex - 1 + total) % total;
        showSlide(currentIndex);
    });

    // Dot navigation
    dots.forEach((dot, i) => {
        dot.addEventListener("click", () => {
            currentIndex = i;
            showSlide(currentIndex);
        });
    });

    // Auto slide every 5 seconds
    setInterval(() => {
        currentIndex = (currentIndex + 1) % total;
        showSlide(currentIndex);
    }, 5000);
});

